exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "slice---src-components-layout-footer-jsx": () => import("./../../../src/components/layout/footer.jsx" /* webpackChunkName: "slice---src-components-layout-footer-jsx" */),
  "slice---src-components-layout-header-jsx": () => import("./../../../src/components/layout/header.jsx" /* webpackChunkName: "slice---src-components-layout-header-jsx" */)
}

